// tslint:disable:variable-name
import { get } from 'lodash'

import { Record, TranslatedString } from '@skinsoft/types'

export const id = (record: Record) => get(record, 'id')

export const recordIdentifier = (record: Record) => _recordIdentifier(record) || get(record, 'recolementIdentificationSchema.numberIdentifier');
export const linkedItemId = (record: Record) => {
    return _linkedItemId(record) ??
        get(record, 'recolementLinkSchema.linkedItem.linkableItem.linkableItem') ??
        get(record, 'recolementLinkSchema.linkedItem.linkableItem') 
}
export const currentState = (record: Record, locale: string) => {
    return _currentState(record, locale) || 
        currenStateValue(record)
}

export const currenStateValue = (record: Record) => {
    return get(record, `workflowSchema.currentState.name`) || 
        get(record, 'workflowSchema.currentState.value')
}

export const currentLocationId = (record: Record): string | undefined => {
    return (get(record, "recolementCheckingSchema.currentLocation.ref") as string | undefined) ??
    get(record, "recolementCheckingSchema.currentLocation")
}

////////////////////////////////
//// Search result specific ////
////////////////////////////////
export const _recordIdentifier = (record: Record) => get(record, 'recolementIdentificationSchema.numberIdentifier.value');
export const _linkedItemId = (record: Record) => get(record, 'recolementLinkSchema.linkedItem.ref');
export const _linkedItemInventoryNumber = (record: Record): TranslatedString | undefined => {
    return get(record, 'recolementLinkSchema.linkedItem.value')
}
export const _linkedItemType = (record: Record): string => {
    return get(record, 'recolementLinkSchema.linkedItem.linkableItemReferenceType') ??
        get(record, 'recolementLinkSchema.linkedItem.referenceType') ??
        ""
}
export const _currentState = (record: Record, locale: string) => get(record, `workflowSchema.currentState.${locale}`)